import { lazy } from 'react';
import { Route } from 'react-router';
const Cart = lazy(() => import('@/pages/funnel/carts/Cart'));

export const CartRoutes = () => {
  return (
    <Route path="/carts">
      <Route index element={<Cart />} />
    </Route>
  );
};
